module.exports = __webpack_public_path__ + "media/waves3.4f71856a.ogg";